import React from "react";
import "./footer.css";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <section className="footer grid grid-cols-1 text-center md:grid-cols-7 md:text-left px-10 py-20">
      <div className="mb-8 md:mb-0 md:col-span-2">
        <div>
          <h2 className="text-3xl font-bold mb-2">PosterGen</h2>
        </div>
        <div className="social justify-center md:justify-start">
          <a href="#">
            <i className="fa fa-facebook" aria-hidden="true"></i>
          </a>
          <a href="#">
            <i className="fa fa-twitter" aria-hidden="true"></i>
          </a>
          <a href="#">
            <i className="fa fa-linkedin" aria-hidden="true"></i>
          </a>
          <a href="#">
            <i className="fa fa-instagram" aria-hidden="true"></i>
          </a>
        </div>
      </div>
      <div className="mb-8 md:mb-0 md:col-span-1">
        <div className="link_box">
          <h4 className="text-2xl">Links</h4>
          <div className="links">
            <Link to="/" className="justify-center md:justify-start">
              <img src="images/nav-bullet.png" alt="" />
              Home
            </Link>
            <Link to="/about" className="justify-center md:justify-start">
              <img src="images/nav-bullet.png" alt="" />
              About
            </Link>
            <Link to="/prompt" className="justify-center md:justify-start">
              <img src="images/nav-bullet.png" alt="" />
              Prompt
            </Link>
            <Link to="/pricing" className="justify-center md:justify-start">
              <img src="images/nav-bullet.png" alt="" />
              Pricing
            </Link>
          </div>
        </div>
      </div>
      <div className="mb-8 md:mb-0 md:col-span-2 md:pr-10">
        <div className="md:pr-2">
          <h4 className="text-2xl">Info</h4>
          <p>
            It is a tool to easily create amazing designs of posters by writing
            simple prompts
          </p>
        </div>
      </div>
      <div className="mb-8 md:mb-0 md:col-span-2">
        <div className="link_box">
          {/* <h4 className="text-2xl">Razorpay</h4> */}
          <div className="links">
            <a
              href="https://merchant.razorpay.com/policy/Mls0TDdcBCjNEk/privacy"
              className="justify-center md:justify-start"
            >
              <img src="images/nav-bullet.png" alt="" />
              Privacy Policy
            </a>
            <a
              href="https://merchant.razorpay.com/policy/Mls0TDdcBCjNEk/terms"
              className="justify-center md:justify-start"
            >
              <img src="images/nav-bullet.png" alt="" />
              Terms & Conditions
            </a>
            <a
              href="https://merchant.razorpay.com/policy/Mls0TDdcBCjNEk/contact_us"
              className="justify-center md:justify-start"
            >
              <img src="images/nav-bullet.png" alt="" />
              Contact Us
            </a>
            <a
              href="https://merchant.razorpay.com/policy/Mls0TDdcBCjNEk/refund"
              className="justify-center md:justify-start"
            >
              <img src="images/nav-bullet.png" alt="" />
              Refund Policy
            </a>
            <a
              href="https://merchant.razorpay.com/policy/Mls0TDdcBCjNEk/shipping"
              className="justify-center md:justify-start"
            >
              <img src="images/nav-bullet.png" alt="" />
              Shipping
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Footer;
